import { G, Path, Rect, Svg, SvgProps } from 'react-native-svg';

export const CarWheelPositions = {
  FRONT_LEFT: 'FRONT_LEFT',
  FRONT_RIGHT: 'FRONT_RIGHT',
  REAR_LEFT: 'REAR_LEFT',
  REAR_RIGHT: 'REAR_RIGHT'
} as const;

export type CarWheelPositionType = (typeof CarWheelPositions)[keyof typeof CarWheelPositions];

interface CarWheelPositionProps extends SvgProps {
  color?: string;
  carSides: CarWheelPositionType[];
  rotate?: boolean;
}

export const CarWheelPosition = ({
  carSides = [],
  rotate = false,
  width: propWidth,
  height: propHeight,
  ...rest
}: CarWheelPositionProps) => {
  // Default dimensions
  const defaultWidth = 20;
  const defaultHeight = 33;

  // Calculate proper scaling - ensure numerical types
  let width = propWidth !== undefined ? Number(propWidth) : defaultWidth;
  let height = propHeight !== undefined ? Number(propHeight) : defaultHeight;

  // When rotated, we need to maintain aspect ratio based on original orientation
  if (rotate) {
    // Calculate scaled dimensions to maintain aspect ratio
    const aspectRatio = defaultWidth / defaultHeight;
    // If width was explicitly provided, calculate height from it
    if (propWidth && !propHeight) {
      height = width / aspectRatio;
    }
    // If height was explicitly provided, calculate width from it
    else if (propHeight && !propWidth) {
      width = height * aspectRatio;
    }
    // If both were provided, honor those values

    // Swap width and height for the rotated view
    const tempWidth = width;
    width = height;
    height = tempWidth;
  }

  // Center coordinates for rotation
  const centerX = 10;
  const centerY = 16.5;

  // Determine which viewBox to use based on rotation
  const viewBox = rotate ? '0 0 33 20' : '0 0 20 33';

  return (
    <Svg viewBox={viewBox} width={width} height={height} fill='none' {...rest}>
      <G
        rotation={rotate ? 270 : 0}
        origin={`${centerX}, ${centerY}`}
        // Translate as needed when rotated to keep content in view
        x={rotate ? 6.5 : 0}
        y={rotate ? -6.5 : 0}
      >
        <Path stroke='#000' strokeLinecap='round' d='m3.5 7-1 1M16.5 7l1 1' />
        <Path
          stroke='#000'
          d='M3.922 3.49a2.5 2.5 0 0 1 2.13-2.395L9.63.561a2.5 2.5 0 0 1 .738 0l3.58.534a2.5 2.5 0 0 1 2.13 2.395l.421 13.518V30a2.5 2.5 0 0 1-2.5 2.5H6A2.5 2.5 0 0 1 3.5 30V17.008L3.922 3.49Z'
        />
        <Rect
          width={3}
          height={8}
          x={4}
          y={6.5}
          fill={carSides.includes('FRONT_LEFT') ? '#000' : '#fff'}
          stroke='#000'
          rx={0.5}
        />
        <Rect
          width={3}
          height={8}
          x={13}
          y={6.5}
          fill={carSides.includes('FRONT_RIGHT') ? '#000' : '#fff'}
          stroke='#000'
          rx={0.5}
        />
        <Rect
          width={3}
          height={8}
          x={4}
          y={21.5}
          fill={carSides.includes('REAR_LEFT') ? '#000' : '#fff'}
          stroke='#000'
          rx={0.5}
        />
        <Rect
          width={3}
          height={8}
          x={13}
          y={21.5}
          fill={carSides.includes('REAR_RIGHT') ? '#000' : '#fff'}
          stroke='#000'
          rx={0.5}
        />
      </G>
    </Svg>
  );
};
